import React from "react";
import Breadcrumbs from "../../../../../components/Breadcrumbs";
import AddEditpage from "./addEditpage";

const EditCall = () => {
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Edit Call"
            title="Main"
            subtitle="Edit Call"
            modalClass="col-auto float-end ms-auto"
          />
          <AddEditpage />
        </div>
      </div>
    </>
  );
};

export default EditCall;
